import React from 'react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
  inputClassName?: string;
  labelClassName?: string;
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const {
    label = '',
    containerClassName = '',
    inputClassName = '',
    labelClassName = '',
    className,
    error,
    ...rest
  } = props;

  return (
    <div className={'flex flex-col gap-1 ' + containerClassName}>
      <div className={'flex gap-2 ' + className}>
        <input
          className={`${error ? 'border-red-500' : 'border-[#CED4DA]'} w-[24px] ` + inputClassName}
          type="checkbox"
          {...rest}
        />

        <label className={'text-sm ' + labelClassName}>{label}</label>
      </div>

      {error && <span className="text-xs text-red-500 ">{error}</span>}
    </div>
  );
};

export { Checkbox };
